import { Box, Typography, Divider } from "@mui/material";
import React from "react";
import attendMeImage from "../assets/home.png";
import attendMeImagePc from "../assets/home_pc.jpg"; // wide banner made for PC
const HeaderBannerPage = () => {
  return (
    <Box sx={{ margin: 0, padding: 0, width: "90vw", overflow: "hidden" }}>
      {/* Banner Section */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          width: "100%", // 100vw caused a horizontal scrollbar on PC
          // mobile: 210px (same as before) | PC: same shape as home_pc.jpg (3200x500) -> nothing cropped
          height: { xs: "210px", md: "auto" },
          aspectRatio: { md: "3200 / 500" },
          overflow: "hidden",
        }}
      >
        <picture>
          {/* PC (900px and wider) -> wide banner */}
          <source media="(min-width: 900px)" srcSet={attendMeImagePc} />
          {/* mobile -> current banner */}
          <img
            src={attendMeImage}
            alt="AttendMe Banner"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </picture>
      </Box>
      {/* Welcome Section */}
      <Typography
        variant="h5"
        align="center
        "
        fontWeight="bold"
        color="#142c54"
        gutterBottom
        sx={{ marginTop: { xs: "150px", md: "calc(100vw * 500 / 3200 - 30px)" } }} // Adjust for the banner height
      >
        {new Date().getHours() < 12 ? "Good Morning" : "Good Evening"}...
      </Typography>
      {/* Divider Section */}
      <Divider
        sx={{
          my: 2,
          borderBottomWidth: 1,
          borderColor: "#142c54",
          width: "90%",
          margin: "16px auto",
        }}
      />
    </Box>
  );
};
export default HeaderBannerPage;